export interface ArticlePreview {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  imageSeq: string;
}

export const articles: ArticlePreview[] = [
  {
    id: '1',
    slug: '/article/best-sugargoo-spreadsheet-2026',
    title: 'Best Sugargoo Spreadsheet 2026 — Ultimate Guide to Top Finds',
    excerpt: 'We analyzed hundreds of community-vetted Sugargoo spreadsheet entries to bring you the definitive list of top-rated sneakers, clothing, and accessories for 2026. Every item is QC-checked and verified by experienced buyers.',
    category: 'Spreadsheet Guides',
    readTime: '8 min read',
    imageSeq: 'v2-art-best-2026',
  },
  {
    id: '2',
    slug: '/article/how-to-use-sugargoo-spreadsheet',
    title: 'How to Use a Sugargoo Spreadsheet — Complete Beginner Walkthrough',
    excerpt: 'Never used a Sugargoo spreadsheet before? This step-by-step guide covers everything from opening your first sheet to importing products and placing your first order with confidence.',
    category: 'Guides',
    readTime: '6 min read',
    imageSeq: 'v2-art-how-to-use',
  },
  {
    id: '3',
    slug: '/article/sugargoo-spreadsheet-vs-pandabuy',
    title: 'Sugargoo Spreadsheet vs Pandabuy — Honest 2026 Comparison',
    excerpt: 'A detailed side-by-side comparison of Sugargoo and Pandabuy spreadsheet communities. We break down fees, shipping speeds, QC quality, and community size so you can choose the right platform.',
    category: 'Comparisons',
    readTime: '7 min read',
    imageSeq: 'v2-art-vs-pandabuy',
  },
  {
    id: '4',
    slug: '/article/best-sneaker-sugargoo-spreadsheet',
    title: 'Best Sneaker Sugargoo Spreadsheet — Top Kicks Under Every Budget',
    excerpt: 'From Nike Dunks to Jordan 1s and Adidas Sambas, our sneaker-focused Sugargoo spreadsheet roundup covers the hottest models with direct links, price breakdowns, and QC photos.',
    category: 'Category Guides',
    readTime: '5 min read',
    imageSeq: 'v2-art-sneakers',
  },
  {
    id: '5',
    slug: '/article/designer-brands-sugargoo-spreadsheet',
    title: 'Designer Brands in Sugargoo Spreadsheet — LV, Dior, Prada & More',
    excerpt: 'Luxury enthusiasts, this one is for you. Explore designer-inspired finds across Louis Vuitton, Dior, Prada, and other premium labels available through Sugargoo spreadsheet links.',
    category: 'Category Guides',
    readTime: '6 min read',
    imageSeq: 'v2-art-designer',
  },
  {
    id: '6',
    slug: '/article/cheap-sugargoo-spreadsheet-finds',
    title: 'Cheap Sugargoo Spreadsheet Finds Under $50 — Budget Picks',
    excerpt: 'You do not need to spend hundreds to look great. Discover our curated selection of budget Sugargoo spreadsheet finds where every single item clocks in under fifty dollars.',
    category: 'Budget Guides',
    readTime: '5 min read',
    imageSeq: 'v2-art-cheap',
  },
  {
    id: '7',
    slug: '/article/streetwear-sugargoo-spreadsheet-guide',
    title: 'Streetwear Sugargoo Spreadsheet Guide — Supreme, Stussy & Bape',
    excerpt: 'Dive deep into the streetwear section of the best Sugargoo spreadsheets. From Supreme hoodies to Bape tees, we highlight the most popular brands and their typical price ranges for 2026.',
    category: 'Category Guides',
    readTime: '7 min read',
    imageSeq: 'v2-art-streetwear',
  },
  {
    id: '8',
    slug: '/article/sugargoo-shipping-guide',
    title: 'Sugargoo Shipping Guide — EMS, DHL & SAL Compared',
    excerpt: 'Shipping can make or break your Sugargoo experience. This comprehensive guide compares EMS, DHL, and SAL shipping methods with real delivery timelines, cost estimates, and pro tips.',
    category: 'Guides',
    readTime: '6 min read',
    imageSeq: 'v2-art-shipping',
  },
  {
    id: '9',
    slug: '/article/top-sugargoo-spreadsheet-categories',
    title: 'Top Sugargoo Spreadsheet Categories — What is Trending Now',
    excerpt: 'Which categories dominate the Sugargoo spreadsheet scene? We analyze popularity trends across sneakers, hoodies, bags, and more to show you where the community is most active.',
    category: 'Spreadsheet Guides',
    readTime: '5 min read',
    imageSeq: 'v2-art-categories',
  },
  {
    id: '10',
    slug: '/article/sugargoo-spreadsheet-for-beginners',
    title: 'Sugargoo Spreadsheet for Beginners — First-Time Buyer Tips',
    excerpt: 'New to the Sugargoo ecosystem? Start here. This beginner-friendly guide walks you through account setup, first spreadsheet navigation, and avoiding common rookie mistakes.',
    category: 'Guides',
    readTime: '8 min read',
    imageSeq: 'v2-art-beginners',
  },
  {
    id: '11',
    slug: '/article/budget-clothing-spreadsheet',
    title: 'Best Budget Clothing Spreadsheet — Style Without Breaking Bank',
    excerpt: 'Looking good does not have to cost a fortune. Our budget clothing spreadsheet roundup features tees, hoodies, and pants that deliver premium looks at bargain prices.',
    category: 'Budget Guides',
    readTime: '5 min read',
    imageSeq: 'v2-art-budget',
  },
  {
    id: '12',
    slug: '/article/luxury-spreadsheet-guide',
    title: 'Luxury Spreadsheet Guide — Premium Finds Worth Every Penny',
    excerpt: 'For those who appreciate the finer things, our luxury spreadsheet guide covers high-end bags, designer accessories, and premium clothing finds that justify their price tags.',
    category: 'Category Guides',
    readTime: '6 min read',
    imageSeq: 'v2-art-luxury',
  },
  {
    id: '13',
    slug: '/article/hidden-gems-sugargoo-spreadsheet',
    title: 'How to Find Hidden Gems in Sugargoo Spreadsheet',
    excerpt: 'The best deals are not always on the first page. Learn the techniques experienced buyers use to uncover hidden gems, underrated sellers, and sleeper picks in any Sugargoo spreadsheet.',
    category: 'Guides',
    readTime: '7 min read',
    imageSeq: 'v2-art-hidden-gems',
  },
  {
    id: '14',
    slug: '/article/updated-sugargoo-spreadsheet-weekly',
    title: 'Updated Sugargoo Spreadsheet — Weekly Picks & Fresh Drops',
    excerpt: 'Stay current with our weekly roundup of the freshest Sugargoo spreadsheet additions. New links, restocked items, and trending products delivered every seven days.',
    category: 'Spreadsheet Guides',
    readTime: '4 min read',
    imageSeq: 'v2-art-weekly',
  },
  {
    id: '15',
    slug: '/article/ultimate-sugargoo-spreadsheet-resource',
    title: 'Ultimate Sugargoo Spreadsheet Resource Hub — Everything You Need',
    excerpt: 'Your one-stop destination for all things Sugargoo spreadsheet. This comprehensive pillar page connects every guide, category breakdown, and comparison article into a complete resource ecosystem.',
    category: 'Spreadsheet Guides',
    readTime: '12 min read',
    imageSeq: 'v2-art-ultimate',
  },
];